import React from "react";
import Skeleton from "components/ui/Skeleton";

const VALUE_TONE = { brand: "text-primary", success: "text-success", warning: "text-warning", danger: "text-danger", muted: "text-text_muted" };

/** A row of counters over a monitor list: [{ label, value, tone?, hint? }]. `note` is the line under them. */
export default function StatTiles({ items, loading, note }) {
  return (
    <div className="space-y-1.5">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {items.map((item) => (
          <div key={item.label} className="rounded-lg border border-border bg-surface px-3 py-2.5">
            <p className="text-[11px] text-text_muted">{item.label}</p>
            {loading ? <Skeleton className="mt-1 h-6 w-14" rounded="rounded-md" /> : <p className={`text-xl font-semibold ${VALUE_TONE[item.tone] ?? "text-text_primary"}`}>{item.value ?? 0}</p>}
            {item.hint && <p className="truncate text-[10px] text-text_muted">{item.hint}</p>}
          </div>
        ))}
      </div>
      {note && <p className="text-[11px] text-text_muted">{note}</p>}
    </div>
  );
}
